import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Button, { ILink } from 'tbk-components/src/components/Button';
import Nav, { NavItem } from './Nav';
import logoTbk from '../../assets/tbk-logo-colour.svg';
import SocialIcons, { SocialIcon } from '../SocialIcons';

export interface IFooterProps extends IBaseElementProps {
	logo?: IImage;
	appTitle?: string;
	appStoreLink?: string;
	appStore?: IImage;
	playStore?: IImage;
	playStoreLink?: string;
	logoURL?: string;
	address?: string;
	contactInfo?: string;
	cta?: ILink;
	socialIcons?: SocialIcon[];
	menusDesktop?: NavItem[][];
	menusMobile?: NavItem[][];
	secondaryMenu?: NavItem[][];
	secondaryMenuMobile?: NavItem[][];
	legalText?: string;
	legalMenu?: NavItem[];
}

const Footer: React.FC<IFooterProps> = ({
	className,
	classNames = [],
	logo,
	appTitle,
	appStore,
	appStoreLink,
	playStore,
	playStoreLink,
	logoURL,
	address,
	contactInfo,
	cta,
	socialIcons = [],
	menusDesktop = [],
	menusMobile = [],
	secondaryMenu = [],
	secondaryMenuMobile = [],
	legalText,
	legalMenu = [],
}) => {
	return (
		<div className={className || cn('footer', ...classNames)}>
			<div className="container">
				<div className="footer__infos">
					<div className="footer__app">
						<h4>{appTitle}</h4>
						<div className="footer__app-icons">
							<a
								href={appStoreLink}
								aria-label="My Big Yellow Bus iPhone app"
								target="_blank"
								rel="noreferrer"
							>
								<Image
									{...appStore}
									className="app-store"
									alt="My Big Yellow Bus iPhone app"
								/>
							</a>
							<a
								href={playStoreLink}
								aria-label="My Big Yellow Bus Android app"
								target="_blank"
								rel="noreferrer"
							>
								<Image
									{...playStore}
									className="app-store"
									alt="My Big Yellow Bus Android app"
								/>
							</a>
						</div>
					</div>
					<div className="footer__centre">
						{logo && (
							<a
								href={logoURL || '/'}
								aria-label="My Big Yellow Bus"
							>
								<Image
									{...logo}
									className="footer__logo"
									alt="My Big Yellow Bus logo"
								/>
							</a>
						)}
						{socialIcons && <SocialIcons icons={socialIcons} />}
					</div>
					{cta && (
						<div className="footer__cta">
							<Button {...cta} />
						</div>
					)}
				</div>
				<div className="footer__inner">
					<div className="footer__menus">
						{menusDesktop.length > 0 &&
							menusDesktop.map((menu, index) => (
								<Nav
									key={index}
									navItems={menu}
									collapseEnabled={false}
									dropdownEnabled={false}
									classNames={['footer__menu__desktop']}
								/>
							))}

						<div className="footer__menu__desktop secondary-menu">
							{secondaryMenu.length > 0 &&
								secondaryMenu.map((menusDesktop, index) => (
									<Nav
										key={index}
										navItems={menusDesktop}
										collapseEnabled={false}
										dropdownEnabled={false}
									/>
								))}
						</div>

						{menusMobile.length > 0 &&
							menusMobile.map((menu, index) => (
								<Nav
									key={index}
									navItems={menu}
									collapseEnabled
									dropdownEnabled={false}
									classNames={['footer__menu__mobile']}
								/>
							))}

						<span className="decor-line--top" />
						{secondaryMenuMobile.length > 0 &&
							secondaryMenuMobile.map((menu, index) => (
								<Nav
									key={index}
									navItems={menu}
									collapseEnabled
									dropdownEnabled={false}
									classNames={[
										'footer__menu__mobile secondary-menu',
									]}
								/>
							))}
						<span className="decor-line--bottom" />
					</div>
				</div>

				{(address || contactInfo) && (
					<div className="footer__contact__mobile">
						{address && (
							<div
								className="footer__address"
								dangerouslySetInnerHTML={{
									__html: address.replace(/\\n/g, '<br>'),
								}}
							/>
						)}

						{contactInfo && (
							<div
								className="footer__contact-info"
								dangerouslySetInnerHTML={{
									__html: contactInfo.replace(/\\n/g, '<br>'),
								}}
							/>
						)}
					</div>
				)}
			</div>
			<div className="footer__legal">
				<div className="container">
					<div className="footer__centre">
						{logo && (
							<a
								href={logoURL || '/'}
								aria-label="My Big Yellow Bus"
							>
								<Image
									{...logo}
									className="footer__logo"
									alt="My Big Yellow Bus logo"
								/>
							</a>
						)}
						{socialIcons && <SocialIcons icons={socialIcons} />}
					</div>
					{legalText && (
						<div className="footer__legal__text">{legalText}</div>
					)}
					{legalMenu && legalMenu.length > 0 && (
						<Nav
							className="footer__legal__menu"
							navItems={legalMenu}
						/>
					)}

					<div className="footer__poweredby">
						<div className="footer__poweredby__tbk">
							<a
								href="https://www.tbkcreative.com/"
								target="_blank"
								aria-label="tbk Creative"
								rel="noreferrer"
							>
								Web Design &amp; Digital Marketing{' '}
								<Image
									src={logoTbk}
									width={46}
									height={23}
									alt="tbk Creative"
								/>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default Footer;
